var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobApplicationIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.307,
    height: 93.979,
    viewBox: "0 0 96.307 93.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "job_application_icon5",
    d: "M35.247,0C27.816,8.706,0,26.754,0,26.754S24.843,39.706,26.754,72.83c22.719-10.4,39.706-20.6,39.706-20.6S67.946,26.541,35.247,0Z",
    transform: "translate(63.072) rotate(60)",
    fill: "#e6ebf1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobApplicationIcon5);
export default __webpack_public_path__ + "static/media/job_application_icon5.9f5610b7b9b58da022deb9e052ef3427.svg";
export { ForwardRef as ReactComponent };